"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dPlotCtorArg = void 0;
/**
 * @public
 * {@inheritDoc ICartesian2dPlotCtorArg}
 */
class Cartesian2dPlotCtorArg {
    constructor(chart, plotOptions, plotArea) {
        this.chart = chart;
        this.plotOptions = plotOptions;
        this.plotArea = plotArea;
    }
}
exports.Cartesian2dPlotCtorArg = Cartesian2dPlotCtorArg;
//# sourceMappingURL=cartesian2d-plot-ctor-arg.js.map